import {BaseRequest} from '../../configs/request';
import {authStore} from '../../store/stores/auth-store';

interface IFeedbackRequest extends BaseRequest {
  postFeedback(data: any, userId: string): Promise<any>;
  postPraise(data: any): Promise<any>;
  postRequestFeedback(data: any, userId: string): Promise<any>;
  deleteFeedbackRequest(requestId: string): Promise<any>;
  fetchRequestFeedback(userId: string): Promise<any>;
  fetchFeedbackRequests(data: any): Promise<any>;
  getFeedback(data: any, userId: string): Promise<any>;
  fetchPublicFeedback(data: any): Promise<any>;
}

export class FeedbackRequestImpl
  extends BaseRequest
  implements IFeedbackRequest {
  url: string = '/users';

  private requestHeader = {
    headers: {
      Authorization: `Bearer ${authStore?.auth?.tokens.access.token}`,
    },
  };

  async postFeedback(data: any, userId: string) {
    const {data: response} = await this.request.post(
      `${this.url}/${userId}/feedback`,
      data,

      {
        headers: {
          Authorization: `Bearer ${authStore.auth?.tokens.access.token}`,
        },
      },
    );
    return response;
  }

  async postPraise(data: any) {
    const {data: response} = await this.request.post(
      `${this.url}/feedback`,
      data,
      {
        headers: {
          Authorization: `Bearer ${authStore.auth?.tokens.access.token}`,
        },
      },
    );
    return response;
  }

  async deleteFeedbackRequest(requestId: string) {
    const {data: response} = await this.request.delete(
      `${this.url}/feedback-request/${requestId}`,

      {
        headers: {
          Authorization: `Bearer ${authStore.auth?.tokens.access.token}`,
        },
      },
    );
    return response;
  }

  async patchFeedback(data: any, feedbackId: string) {
    const {data: response} = await this.request.patch(
      `${this.url}/feedback/${feedbackId}`,
      data,

      {
        headers: {
          Authorization: `Bearer ${authStore.auth?.tokens.access.token}`,
        },
      },
    );
    return response;
  }

  async postRequestFeedback(data: any, reviewerId: string) {
    const {data: response} = await this.request.post(
      `${this.url}/${reviewerId}/feedback-request`,
      data,
      {
        headers: {
          Authorization: `Bearer ${authStore.auth?.tokens.access.token}`,
        },
      },
    );
    return response;
  }
  async fetchRequestFeedback(reviewerId: string) {
    return this.fetchFeedbackRequests({reviewer: reviewerId});
  }

  async fetchFeedbackRequests(data: any = {}) {
    const query = this.buildQuery({...data, paginate: false});
    const {data: response} = await this.request.get(
      `${this.url}/feedback-request?${query}`,
      {
        headers: {
          Authorization: `Bearer ${authStore.auth?.tokens.access.token}`,
        },
        useCache: false,
      },
    );
    return response;
  }

  private buildQuery(data: Record<string, unknown>) {
    const params = new URLSearchParams();

    Object.entries(data).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') return;
      params.set(key, String(value));
    });

    return params.toString();
  }

  async fetchFeedbackReporting(data: any) {
    const {
      impression,
      manager,
      startDate,
      endDate,
      user,
      values,
      groupBy,
      group,
      sortByCount,
    } = data;

    const {data: response} = await this.request.get(
      `/reports/feedback?paginate=false${
        startDate ? `&startDate=${startDate}` : ''
      }${values ? `&values=${values}` : ''}${group ? `&group=${group}` : ''}${
        endDate ? `&endDate=${endDate}` : ''
      }${impression ? `&impression=${impression}` : ''}${
        groupBy ? `&groupBy=${groupBy}` : ''
      }${sortByCount ? `&sortByCount=${sortByCount}` : ''}${
        user ? `&user=${user}` : ''
      }${manager ? `&manager=${manager}` : ''}`,
      {
        headers: {
          Authorization: `Bearer ${authStore.auth?.tokens.access.token}`,
          useCache: false,
        },
      },
    );
    return response;
  }

  async getFeedback(data: any, userId: string) {
    const query = this.buildQuery(data || {});

    const {data: response} = await this.request.get(
      `${this.url}/${userId}/feedback${query ? `?${query}` : ''}`,
      {
        headers: {
          Authorization: `Bearer ${authStore.auth?.tokens.access.token}`,
        },
        useCache: false,
      },
    );
    return response;
  }

  async getSentimentAnalytics(text: string) {
    const {data: response} = await this.request.get(
      `workspaces/sentiment-analysis?text=${encodeURIComponent(text)}`,
      {
        headers: {
          Authorization: `Bearer ${authStore.auth?.tokens.access.token}`,
        },
      },
    );
    return response;
  }
  async fetchPublicFeedback(data: any) {
    const query = this.buildQuery({
      ...data,
      visibility: 'public',
      sortBy: `createdAt:${data?.sortBy || 'desc'}`,
    });
    const {data: response} = await this.request.get(
      `${this.url}/feedback?${query}`,
      {
        headers: {
          Authorization: `Bearer ${authStore.auth?.tokens.access.token}`,
        },
        useCache: false,
      },
    );
    return response;
  }
  async fetchDirectReportsFeedback(data: any) {
    const query = this.buildQuery(data || {});
    const {data: response} = await this.request.get(
      `${this.url}/feedback${query ? `?${query}` : ''}`,
      {
        headers: {
          Authorization: `Bearer ${authStore.auth?.tokens.access.token}`,
        },
        useCache: false,
      },
    );
    return response;
  }
}
